export var defaultParams = [
    { key: "ui_header", convertTo: "boolean" },
    { key: "ui_nav", convertTo: "boolean" },
    { key: "ui_footer", convertTo: "boolean" },
    { key: "ui_return", convertTo: "boolean" },
    { key: "ui_share", convertTo: "boolean" },
    { key: "ui_theme" },
    { key: "ui_style" },
    { key: "hg_token" },
    { key: "ctr_orientation" },
    { key: "ctr_webview", convertTo: "boolean" },
    { key: "i18n_lang" },
    { key: "media_audio", convertTo: "boolean" },
    { key: "media_video", convertTo: "boolean" },
    { key: "func_accountSwitch", convertTo: "boolean" },
    { key: "func_downloadGuide", convertTo: "boolean" },
    { key: "source_from" },
    { key: "source_uid" },
    { key: "share_type" },
    { key: "share_by" },
    { key: "collect_uid" },
    { key: "collect_phone" },
];
